import { Link } from 'react-router-dom'
import { ParceiroTermosLeitura } from './ParceiroTermosAceite'
import { PARCEIROS_ACCENT, PARCEIROS_CADASTRO_PATH } from './parceirosBrand'
import { PARCEIROS_HERO_PONTOS, PARCEIROS_PUBLIC_NAV } from './parceirosPublicCopy'

export function ParceirosPublicHero() {
  return (
    <section className='grid items-center gap-8 md:grid-cols-[minmax(0,1fr)_minmax(240px,380px)] md:gap-10'>
      <div className='grid max-w-3xl gap-5'>
        <p className='text-[11px] font-medium uppercase tracking-[0.28em] text-white/55'>
          Programa de Parceiros Rocket Search
        </p>
        <h1 className='max-w-xl text-4xl font-black leading-[1.1] md:text-5xl'>
          Indique lojistas. A Rocket conduz a venda. Você ganha pelo resultado.
        </h1>
        <p className='max-w-lg text-base leading-7 text-white/70'>
          Conecte a Rocket Search a e-commerces que querem melhorar a busca e a descoberta de produtos. Nosso time
          assume o contato, a reunião e a proposta; você acompanha tudo pelo portal e recebe comissão quando um cliente
          novo fecha e o pagamento é confirmado.
        </p>
        <ul className='grid gap-2 text-sm text-white/80'>
          {PARCEIROS_HERO_PONTOS.map((item) => (
            <li key={item} className='flex items-start gap-2'>
              <span className='mt-1 h-1.5 w-1.5 shrink-0 rounded-full bg-[#e91e63]' aria-hidden />
              {item}
            </li>
          ))}
        </ul>
        <nav className='flex flex-wrap gap-2 text-sm text-white/70' aria-label='Seções do programa'>
          {PARCEIROS_PUBLIC_NAV.map((item) => (
            <a key={item.href} href={item.href} className='rounded-full border border-white/15 px-3 py-1.5 hover:bg-white/10'>
              {item.label}
            </a>
          ))}
        </nav>
        <div className='flex flex-wrap items-center gap-3 pt-1'>
          <Link
            to={PARCEIROS_CADASTRO_PATH}
            className='rounded-full px-5 py-3 text-sm font-medium text-white active:scale-95'
            style={{ background: PARCEIROS_ACCENT }}
          >
            Quero me cadastrar grátis
          </Link>
          <a href='#como-funciona' className='rounded-full border border-white/20 px-5 py-3 text-sm font-medium text-white hover:bg-white/10'>
            Ver como funciona
          </a>
        </div>
        <p className='max-w-xl text-sm leading-6 text-white/50'>
          Cadastro sujeito à validação.{' '}
          <ParceiroTermosLeitura label='Consulte os critérios e condições do programa.' />
        </p>
      </div>
      <img
        src='/rki-indique.png'
        alt='RKI, mascote da Rocket Search, com a placa Indique e Ganhe'
        width={856}
        height={1024}
        className='mx-auto h-auto w-full max-w-[340px] object-contain md:max-w-none'
      />
    </section>
  )
}
